import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AppMainComponent } from './layouts/main-layout/app.main.component';
import { AppNotfoundComponent } from './pages/app.notfound.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppLoginComponent } from './pages/app.login.component';
import { QuicklinkStrategy } from 'ngx-quicklink';
import { AppModule } from './app.module';
import { AuthGuardService } from './services/auth-guard.service';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { SaleRecordComponent } from './llb/sale-record/sale-record.component';
import { WeightConfigurationComponent } from './llb/weight-configuration/weight-configuration.component';
import { CategoryComponent } from './llb/category/category.component';
import { ProductComponent } from './llb/product/product.component';
import { ReportByDateComponent } from './llb/report-by-date/report-by-date.component';
import { ReportUnitProductComponent } from './llb/report-unit-product/report-unit-product.component';
import { ReportDetailComponent } from './llb/report-detail/report-detail.component';
import { LlbListComponent } from './llb/users/index/index.component';
import { TypeCustomerComponent } from './llb/type-customer/type-customer.component';
import { CommissionsForSaleComponent } from './llb/commissions-for-sale/commissions-for-sale.component';
import { CommissionQualityComponent } from './llb/commission-quality/commission-quality.component';
import { CommissionForStageComponent } from './llb/commission-for-stage/commission-for-stage.component';
import { ListTitleComponent } from './llb/list-title/list-title.component';
import { CategoryUnitComponent } from './llb/category-unit/category-unit.component';
import { GroupServiceProductComponent } from './llb/group-service-product/group-service-product.component';
import { ServiceProductComponent } from './llb/service-product/service-product.component';
import { StaffManagerComponent } from './llb/staff-manager/staff-manager.component';
import { CalculateUnitComponent } from './llb/calculate-unit/calculate-unit.component';
import { CommissionsForServiceComponent } from './llb/commissions-for-service/commissions-for-service.component';
import { SaleAssociateComponent } from './llb/sale-associate/sale-associate.component';

export const routes: Routes = [
  {
    canActivate: [AuthGuardService],
    path: '',
    component: AppMainComponent,
    children: [
      { path: 'sale-record', component: SaleRecordComponent },
      { path: 'weight-configuration', component: WeightConfigurationComponent },
      {
        path: 'client-template',
        loadChildren: () =>
          import('./client-template/client-template.module').then(
            (m) => m.ClientTemplateModule
          ),
      },
      {
        path: 'core',
        loadChildren: () =>
          import('./core/core.module').then((m) => m.CoreModule),
      },
      { path: 'llb', component: LlbListComponent },
      { path: 'category', component: CategoryComponent },
      { path: 'product', component: ProductComponent },
      { path: 'report-by-date', component: ReportByDateComponent },
      { path: 'report-unit-product', component: ReportUnitProductComponent },
      { path: 'report-detail', component: ReportDetailComponent },
      { path: 'calculate-unit', component: CalculateUnitComponent },
      { path: 'type-customer', component: TypeCustomerComponent },
      { path: 'commissions-for-sale', component: CommissionsForSaleComponent },
      {
        path: 'group-service-product',
        component: GroupServiceProductComponent,
      },
      { path: 'service-product', component: ServiceProductComponent },
      { path: 'staff-manager', component: StaffManagerComponent },
      {
        path: 'commissions-for-quanlity',
        component: CommissionQualityComponent,
      },
      { path: 'commissions-for-stage', component: CommissionForStageComponent },
      { path: 'list-title', component: ListTitleComponent },
      { path: 'category-unit', component: CategoryUnitComponent },
      {
        path: 'commissions-for-service',
        component: CommissionsForServiceComponent,
      },
      { path: 'sale-associate', component: SaleAssociateComponent },
    ],
  },
  { path: 'error', component: AppErrorComponent },
  { path: 'access', component: AppAccessdeniedComponent },
  { path: 'notfound', component: AppNotfoundComponent },
  {
    path: 'login',
    component: LoginLayoutComponent,
    children: [{ path: '', component: AppLoginComponent }],
  },
  { path: '**', redirectTo: '/notfound' },
];
export const AppRoutes: ModuleWithProviders<AppModule> = RouterModule.forRoot(
  routes,
  { preloadingStrategy: QuicklinkStrategy }
);
